export default {
  state: { // тут ВЫБРАННЫЕ(не все) в фильтре элементы для их отображения
    tlu: [], // нужен только для отображения в фильтрах
    rightType: [], // нужен только для отображения в фильтрах
    typeZu: [], // нужен только для отображения в фильтрах
    rightOwnerGovernanceSp: [], // нужен только для отображения в фильтрах
    region: [], // нужен только для отображения в фильтрах
    tluTreeId: null,
    typeZuTreeId: null,
    rightTypeTreeId: null,
    rightOwnerGovernanceSpTreeId: null,
    regionTreeId: null
  },
  mutations: {
    setValue (state, keyValue) {
      state[keyValue.key] = keyValue.value
    },
    delFlterId (state, e) {
      let idIndex = state[e.key].findIndex(item => {
        return item.id === e.id
      })
      if (idIndex !== -1) {
        state[e.key].splice(idIndex, 1)
      }
    }
  },
  actions: {
    SET_IDS ({commit}, keyId) {
      commit('setValue', keyId)
    },
    SET_VALUE ({commit}, keyValue) {
      commit('setValue', keyValue)
    },
    delFlterId ({commit}, keyValue) {
      commit('delFlterId', keyValue)
    }
  },
  getters: {
    SELECTED_TLU: state => {
      return state.tlu
    },
    SELECTED_TYPE_ZU_LIST: state => {
      return state.typeZu
    },
    SELECTED_RIGHT_OWNER_GOVERNANCE_SP: state => {
      return state.rightOwnerGovernanceSp
    },
    SELECTED_RIGHT_TYPE: state => {
      return state.rightType
    },
    SELECTED_REGION: state => {
      return state.region
    }
  }
}



// WEBPACK FOOTER //
// ./src/storages/modules/filterStore.js